export const faqData = [
  {
    question: '宅男视频需要下载APP吗？',
    answer: '不需要！宅男视频是纯网页版视频平台，无需下载任何APP。只需打开浏览器访问我们的网站，即可流畅观看高清视频，不占用手机存储空间。',
  },
  {
    question: '为什么宅男视频观看不缓冲、不卡顿？',
    answer: '宅男视频接入久久视频、小蓝视频、豆花视频等多个稳定视频平台，并采用了智能预加载技术和自适应码率技术，根据您的网络状况自动优化播放体验，确保流畅不缓冲。',
  },
  {
    question: '宅男视频支持哪些清晰度？',
    answer: '我们支持从480P到4K超高清的多种清晰度选择。具体可选清晰度取决于片源本身，热门影片通常支持1080P和4K画质。您可以在播放器中自由切换清晰度。',
  },
  {
    question: '久久视频在线观看需要注册会员吗？',
    answer: '通过宅男视频平台观看久久视频、小蓝视频、豆花视频等内容完全免费，无需注册会员。我们致力于为广大用户提供免费高清的观影体验。',
  },
  {
    question: '视频加载慢或播放卡顿怎么办？',
    answer: '如果遇到播放卡顿，建议您：1）检查网络连接是否稳定；2）尝试降低清晰度；3）关闭其他占用带宽的应用；4）刷新页面重试。如问题持续，请联系我们的客服。',
  },
  {
    question: '豆花视频的内容多久更新一次？',
    answer: '豆花视频的内容每日更新，热门影视剧集会在播出后第一时间上线。宅男视频会同步展示最新的豆花视频内容，让您不错过任何精彩。',
  },
  {
    question: '宅男视频可以在电视上观看吗？',
    answer: '可以！宅男视频支持投屏功能，您可以将手机或电脑上的视频投射到智能电视上观看。支持DLNA和AirPlay协议，大屏观影体验更加震撼。',
  },
  {
    question: '小蓝视频的内容和久久视频有什么区别？',
    answer: '小蓝视频和久久视频各有特色内容。小蓝视频偏重热门剧集和综艺节目，久久视频则在电影和纪录片方面更加丰富。宅男视频聚合了多个平台的优质内容，您可以在一个网站上畅享所有资源。',
  },
];